import {InjectionToken} from '@angular/core'

export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')

export interface IEnvironment {
  // Start with this, add more if needed.
  production: boolean
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')

export const WINDOW = new InjectionToken<Window>('window')